import { iTaojinAppUtil } from '@/assets/utils/iTaojinAppUtil';
export default {
    goBack() {
        /*if ( this.isIOSApp() ) {
            window.webkit.messageHandlers['goBack'].postMessage(null);
            return;
        }

        if ( this.isAndroidApp() ) {
            window.androidNative.goBack();
            return;
        }*/

        iTaojinAppUtil.callNativeFun('goBack');
        return;

        console.log("#10 AppNative.goBack, not ios or android");
    },

    getAndroidToken() {
        return this.isAndroidApp() ? window.androidNative.getNativeToken() : null;
    },

    isMobile() {
        return this.isMobileApp() || this.isMobileWeb();
    },

    isMobileApp() {
        return this.isAndroidApp() || this.isIOSApp();
    },

    isIOSApp() {
        return !!window.webkit && !!window.webkit.messageHandlers && !!window.webkit.messageHandlers['androidNative'];
    },

    isAndroidApp() {
        return !!window.androidNative && !!window.androidNative.getNativeToken;
    },

    isMobileWeb() {
        return this.isAndroidWeb() || this.isIOSWeb();
    },

    isIOSWeb() {
        var ua = navigator.userAgent;
        return ua.match(/(iPhone\sOS)\s([\d_]+)/);
    },

    isAndroidWeb() {
        var ua = navigator.userAgent;
        return ua.match(/(Android)\s+([\d.]+)/);
    }
};


// WEBPACK FOOTER //
// ./src/assets/utils/AppNative.js